import React, { Fragment, useState, useRef } from 'react';
import close from '../assets/images/close-circle.svg';
import checkBox from '../assets/images/check_box.svg';
import arrowDown from '../assets/images/chevron-down.svg';
import MediaComponent from './activity/MediaComponent';
import angleDown from '../assets/images/angle_up_down.svg';
import checkmarkSaved from '../assets/images/model/checkmark_saved.svg';

const regex = /[\r\n]/;

const Option = ({ option, optionIndex, index, setQuestions, editing, isMore, question, defaultOptions }) => {
  const [isShowingFull, setIsShowingFull] = useState(false);
  const textAreaRef = useRef(null);

  const renderMedia = option.type === 'image' || option.type === 'video' || option.type === 'audio';

  return (
    <>
      {isMore ? (
        <div className={`parent_input_with_image edit-image-mscq mb-12 ${editing ? 'parent_input_edit' : 'parent_input_save'}`}>
          <div className='form-group option-wrapper' key={optionIndex}>
            {editing ? (
              <Fragment>
                {1 && (
                  <img
                    className='option-close'
                    src={close}
                    alt='close'
                    onClick={() => {
                      setQuestions((old) => ({
                        ...old,
                        questions: old.questions.map((q, qi) =>
                          qi === index
                            ? {
                                ...q,
                                options: q.options.filter((o, oi) => oi !== optionIndex),
                              }
                            : q
                        ),
                      }));
                    }}
                  />
                )}
                <img
                  className={`option-check cursor ${option.isCorrect ? 'correct-option' : ''}`}
                  src={checkBox}
                  alt='check'
                  onClick={() => {
                    setQuestions((old) => ({
                      ...old,
                      questions: old.questions.map((q, qi) =>
                        qi === index
                          ? {
                              ...q,
                              options: q.options.map((o, oi) => (oi === optionIndex ? { ...o, isCorrect: !o.isCorrect } : { ...o, isCorrect: false })),
                            }
                          : q
                      ),
                    }));
                  }}
                />
                {regex.test(option.text) && (
                  <img
                    className={`option-arrow-down cursor ${option.isCorrect ? 'correct-option' : ''} ${isShowingFull ? 'reversed' : ''}`}
                    src={arrowDown}
                    alt='check'
                    onClick={() => {
                      setIsShowingFull(!isShowingFull);
                    }}
                  />
                )}
              </Fragment>
            ) : (
              option.isCorrect && <img className='option-close' src={checkmarkSaved} alt='check' value={option.text} />
            )}
            <div className='parent_input'>
              <div className='order-number'>
                <label className='num'>{String.fromCharCode(65 + optionIndex)}</label>
              </div>

              <textarea
                type='text'
                ref={textAreaRef}
                style={{
                  height: `${textAreaRef.current ? textAreaRef.current.scrollHeight : 40}px`,
                  minHeight: editing ? '40px' : '32px',
                }}
                value={option.text}
                className={`${editing ? 'orderlist-input' : 'orderlist-input option_save_state option_saved_1'}`}
                placeholder={option.type === 'text' ? `Add text` : `Add text (optional)`}
                readOnly={!editing}
                onChange={(e) => {
                  setQuestions((old) => ({
                    ...old,
                    questions: old.questions.map((q, qi) =>
                      index === qi
                        ? {
                            ...q,
                            options: q.options.map((o, oi) => (oi === optionIndex ? { ...o, text: e.target.value } : o)),
                          }
                        : q
                    ),
                  }));
                }}
              />
              {/* <div className="dropdown-arrow">
                <img src={angleDown} alt="down arrow" />
              </div> */}
            </div>
            {renderMedia && (
              <MediaComponent
                media={option}
                onSuccess={(fileUrl, alt, at) => {
                  setQuestions((old) => ({
                    ...old,
                    questions: old.questions.map((q, qi) =>
                      index === qi
                        ? {
                            ...q,
                            options: q.options.map((o, oi) => (oi === optionIndex ? { ...o, url: fileUrl } : o)),
                          }
                        : q
                    ),
                  }));
                }}
                isEditing={true}
              />
            )}
          </div>
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export default Option;
